<template>
  <div class="flex flex-col w-full lg:w-1/2 lg:p-2 self-stretch">
    <div class="flex w-full p-4 bg-white lg:shadow lg:rounded h-full">
      <div class="flex flex-col flex-grow pr-4">
        <div class="font-bold flex items-center">
          <span
            class="text-green-600 bg-green-200 p-1 text-xs rounded mr-2 uppercase font-bold"
            v-if="newProduct"
            >new</span
          >{{ title }}
        </div>
        <read-more
          class="text-sm text-gray-700 mt-2"
          :text="description"
          link="#"
          :max-chars="200"
        ></read-more>
        <span
          v-if="price"
          class="text-sm mt-2"
          :class="{'text-pink-700': covid_price}"
          >${{ price }}</span
        >
      </div>
      <div class="flex self-start flex-shrink-0" v-if="imgUrl">
        <img
          :style="`background-image:url(${imgUrl})`"
          alt=""
          class="w-20 h-20 bg-cover rounded border-0"
        />
      </div>
    </div>
    <div class="w-full h-px pl-4 lg:hidden">
      <div class="h-px bg-gray-300"></div>
    </div>
  </div>
</template>

<script>
module.exports = {
  data: function() {
    return {
      greeting: "Hello",
    }
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: false,
    },
    price: {
      type: Number,
      required: false,
    },
    imgUrl: {
      type: String,
      required: false,
    },
    newProduct: {
      type: Boolean,
    },
    covid_price: {
      type: Boolean,
    },
  },
}
</script>

<style scoped></style>
